import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana: React.FC = () => {
  const Notice1 = `
  📌 🏥 ¿A QUÉ TIENES DERECHO?: Atención médica 100% garantizada: Urgencias, cirugías, hospitalización y traslados. Ninguna clínica puede negártela, no requiere autorización ni importa tu estado de afiliación. Indemnizaciones y gastos funerarios: Para fallecidos o incapacidad permanente (requiere certificado de Gestión del Riesgo).

❌ IMPORTANTE: La ADRES no cubre daños materiales en viviendas.

📩 ENLACES Y CORREOS OFICIALES🔗 Paso a paso para reclamaciones: servicios.adres.gov.co/ecat/procesos-y-procedimientos-ecat/procedimientos-ecat
✉️ Atención a dudas: corrrespondencia1@adres.gov.co correspondencia2@adres.gov.co

#Cali no está sola. Desde El Cambio es con vos te acompañamos. ¡Comparte este post para ayudar a quien lo necesita! 📲
  `;
  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/reels/DcRQm2ft8MU/"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>
          ¡ATENCIÓN! Si tú o un familiar resultaron afectados por el terremoto,
          la ADRES ofrece cobertura de salud y ayudas económicas. ¡Guarda este
          post!
        </h1>
        <h5 className={style.Fecha}>Agosto 20 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana;
